// Re-export the CDN jQuery so that every `import … from 'jquery'` (including
// inside owl.carousel, bootstrap, etc.) resolves to the single global
// instance loaded in layout.inc.  This eliminates the duplicate-jQuery bug
// where plugins were attached to one instance while inline scripts used another.
//
// Do not snapshot `window.jQuery` at module load: the Vite bundle can evaluate
// before the CDN script has run, leaving `default` as `undefined`. Rollup’s
// CJS interop can mis-handle a snapshot `undefined` default. Resolve from
// `window` on each access instead.

function resolveJq() {
    const $ = window.jQuery;
    if (!$) {
        throw new Error(
            'PACE: window.jQuery is missing. Load the jQuery script before the Vite bundle.'
        );
    }
    return $;
}

const jQuery = new Proxy(function () {}, {
    apply(_target, thisArg, args) {
        return resolveJq().apply(thisArg, args);
    },
    get(_target, prop) {
        const $ = resolveJq();
        const value = $[prop];
        return typeof value === 'function' ? value.bind($) : value;
    },
});

export default jQuery;
export { jQuery, jQuery as $ };
